import ApiHandler from './ApiHandler';

export default {
    getAllLeaguesAndStats: () => ApiHandler.get('/leagues'),
    publishLeagues: data => ApiHandler.put('/leagues/update', data)
};
